import Vue from 'vue'
import store from './store'
import VueCompositionAPI from '@vue/composition-api'
import { getAttributeValue } from "@/shared/filters/utils-filter"
import StudentExchangeProgressColumnWidget
    from "@/apps/StudentExchangeProgressColumnWidget/StudentExchangeProgressColumnWidget.vue"

Vue.config.productionTip = false
Vue.use(VueCompositionAPI)

let widgetEls = document.querySelectorAll('student-exchange-progress-column-widget')
if (widgetEls.length) {
    widgetEls.forEach(el => {
        new Vue({
            el: el,
            store,
            render(h: any) {
                return h(StudentExchangeProgressColumnWidget, {
                    props: {
                        labels: getAttributeValue(el, 'labels', true),
                        progressLabels: getAttributeValue(el, 'progress-labels', true),
                    }
                })
            }
        })
    })
}
